export default __webpack_public_path__ + "static/media/background-waves.2c8ca690.png";